import { FormikValues, useFormik } from 'formik';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';
import {
  AppealsConfirmValidationForm,
  FIELD_DESCRIPTION,
  FIELD_ID,
} from './appeals-confirm-schema';

interface useAppealsConfirmProps {
  onSubmit: (values: FormikValues) => void;
}

export const useAppealsConfirm = ({ onSubmit }: useAppealsConfirmProps) => {
  const { t } = useTranslation();

  const handleFieldChange = (field: string, e: any) => {
    formik.setFieldValue(field, e.target.value);
    formik.setFieldError(field, null);
  };

  const hasError = (field: string) => {
    return (
      get(formik, ['touched', ...field.split('.')], false) &&
      Boolean(get(formik, ['errors', ...field.split('.')], false))
    );
  };

  const getErrorMessage = (field: string) => {
    if (!hasError(field)) return ' ';
    const key = get(formik, ['errors', ...field.split('.')], 'error');
    if (key.includes('error.')) {
      return t(key, 'Ошибка');
    }
    return key;
  };

  const formik: any = useFormik({
    initialValues: {
      [FIELD_ID]: null,
      // [FIELD_POINT]: null,
      [FIELD_DESCRIPTION]: '',
    },
    validationSchema: AppealsConfirmValidationForm,
    validateOnBlur: true,
    validateOnChange: false,
    onSubmit: onSubmit,
  });

  return {
    formik,
    handleFieldChange,
    hasError,
    getErrorMessage,
  };
};
